/* Publish by EComposer at 2026-06-13 11:11:37*/
;try{
 
  const QUESTIONS = [
  {
    id: 1,
    emoji: '💰',
    label: 'Budget',
    question: 'Quel est votre budget pour le cadeau maîtresse ?',
    cols: 2,
    options: [
      {
        label: 'Moins de 10€',
        emoji: '🌱',
        desc: 'Une belle attention pleine de sens',
        budgetKey: 'UNDER_10',
        scores: { GALET: 3, ENCENS: 2 }
      },
      {
        label: '10€ à 20€',
        emoji: '🌸',
        desc: 'Un vrai cadeau bien-être',
        budgetKey: 'BETWEEN_10_20',
        scores: { GALET: 2, BRACELET: 3, BOUGIE: 2 }
      },
      {
        label: '20€ à 35€',
        emoji: '✨',
        desc: 'Généreux & vraiment original',
        budgetKey: 'BETWEEN_20_35',
        scores: { POCHETTE: 3, BRACELET: 2, TRESORS: 2, FEMME: 1 }
      },
      {
        label: '35€+ (cagnotte)',
        emoji: '🎁',
        desc: 'Toute la classe dit merci !',
        budgetKey: 'OVER_35',
        scores: { COFFRET: 3, POCHETTE: 2, TRESORS: 3, FEMME: 2, PARFUM: 1 }
      }
    ]
  },
  {
    id: 2,
    emoji: '👩‍🏫',
    label: 'Profil',
    question: 'Comment décririez-vous la maîtresse ?',
    cols: 2,
    options: [
      {
        label: 'Nature & bien-être',
        emoji: '🌿',
        desc: 'Elle aime les soins naturels & artisanaux',
        scores: { GALET: 3, ENCENS: 2, BOUGIE: 1, TRESORS: 1 }
      },
      {
        label: 'Chic & élégante',
        emoji: '💎',
        desc: 'Toujours impeccable, style raffiné',
        scores: { POCHETTE: 3, BRACELET: 2, PARFUM: 2, TRESORS: 1, FEMME: 1 }
      },
      {
        label: 'Zen & spirituelle',
        emoji: '🪔',
        desc: 'Méditation, pleine conscience, symboles',
        scores: { ENCENS: 3, BRACELET: 2, BOUGIE: 3, PARFUM: 2 }
      },
      {
        label: 'Dynamique & moderne',
        emoji: '⚡',
        desc: 'Active, moderne, toujours en mouvement',
        scores: { GALET: 2, BRACELET: 2 }
      }
    ]
  },
  {
    id: 3,
    emoji: '💆',
    label: 'Envie',
    question: 'Elle mérite avant tout…',
    cols: 3,
    options: [
      {
        label: 'Un moment spa',
        emoji: '🛁',
        desc: 'Se ressourcer sous la douche',
        scores: { GALET: 4 }
      },
      {
        label: 'Un beau bijou',
        emoji: '📿',
        desc: 'Porter quelque chose de joli',
        scores: { BRACELET: 3, POCHETTE: 1 }
      },
      {
        label: 'Une ambiance zen',
        emoji: '🪔',
        desc: 'Atmosphère apaisante à la maison',
        scores: { ENCENS: 3, BOUGIE: 3, PARFUM: 2 }
      }
    ]
  },
  {
    id: 4,
    emoji: '👥',
    label: 'Type',
    question: "C'est un cadeau…",
    cols: 2,
    options: [
      {
        label: 'De ma famille',
        emoji: '🏠',
        desc: 'Cadeau personnel & chaleureux',
        scores: { GALET: 1, BRACELET: 1, ENCENS: 1 }
      },
      {
        label: 'De toute la classe',
        emoji: '🏫',
        desc: 'Cagnotte collective & généreux',
        scores: { POCHETTE: 2, COFFRET: 3 }
      }
    ]
  },
  {
    id: 5,
    emoji: '🎯',
    label: 'Valeur',
    question: 'Ce qui compte le plus pour vous ?',
    cols: 2,
    options: [
      {
        label: "L'originalité",
        emoji: '🌟',
        desc: 'Sortir des sentiers battus',
        scores: { GALET: 3, ENCENS: 2, TRESORS: 3 }
      },
      {
        label: 'Le côté naturel',
        emoji: '🌱',
        desc: 'Artisanal, éco-responsable & vegan',
        scores: { GALET: 2, ENCENS: 3 }
      },
      {
        label: "L'élégance",
        emoji: '✨',
        desc: 'Un beau cadeau qui fait un effet',
        scores: { POCHETTE: 3, BRACELET: 2, PARFUM: 2, FEMME: 2, BOUGIE: 1 }
      },
      {
        label: 'Le rapport qualité/prix',
        emoji: '💚',
        desc: 'Maxi plaisir pour le budget familial',
        scores: { GALET: 2, ENCENS: 2 }
      }
    ]
  }
];

const PRODUCTS = {
  GALET: {
    name: 'Soins & rituels bien-être',
    desc: 'Petites attentions spa et cocooning pour offrir un vrai moment de détente.',
    price: 'À partir de 4,90€',
    emoji: '🚿',
    tag: 'Bien-être'
  },
  BRACELET: {
    name: 'Bracelets & bijoux symboliques',
    desc: 'Pierres naturelles, bijoux porteurs de sens et cadeaux délicats à porter au quotidien.',
    price: 'À partir de 8,90€',
    emoji: '📿',
    tag: 'Porteur de sens'
  },
  POCHETTE: {
    name: 'Cadeaux élégants & raffinés',
    desc: 'Pochettes, fleurs de savon et jolis objets qui font un très bel effet à l’ouverture.',
    price: 'À partir de 19,90€',
    emoji: '👝',
    tag: 'Élégance'
  },
  ENCENS: {
    name: 'Ambiance zen & spirituelle',
    desc: 'Brûleurs, encens et objets d’atmosphère pour une maison plus apaisante.',
    price: 'À partir de 9,50€',
    emoji: '🪔',
    tag: 'Zen attitude'
  },
  COFFRET: {
    name: 'Coffrets cadeaux bien-être',
    desc: 'Les plus beaux coffrets pour une cagnotte de classe ou un cadeau collectif.',
    price: 'À partir de 38,90€',
    emoji: '🎁',
    tag: 'Cagnotte ❤️'
  },
  BOUGIE: {
    name: 'Bougies parfumées & cocooning',
    desc: 'Des bougies pour aider la maîtresse à souffler enfin après la journée.',
    price: 'À partir de 7,90€',
    emoji: '🕯️',
    tag: 'Ambiance & douceur'
  },
  TRESORS: {
    name: 'Cadeaux originaux & sensoriels',
    desc: 'Des idées plus marquantes, visuelles ou voyageuses pour sortir du cadeau classique.',
    price: 'À partir de 25,90€',
    emoji: '🌍',
    tag: 'Original & voyage'
  },
  PARFUM: {
    name: "Parfums d'intérieur & diffusion",
    desc: 'Sprays, diffuseurs et ambiance maison pour un cadeau élégant et sensoriel.',
    price: 'À partir de 7,90€',
    emoji: '🌸',
    tag: 'Zen & sensoriel'
  },
  FEMME: {
    name: 'Cadeaux premium & féminins',
    desc: 'Des cadeaux plus complets et raffinés pour marquer la fin d’année scolaire.',
    price: 'À partir de 39,90€',
    emoji: '💝',
    tag: 'Cadeau complet'
  }
};

const BUDGET_RANGES = {
  UNDER_10: { min: 0, max: 10 },
  BETWEEN_10_20: { min: 10, max: 20 },
  BETWEEN_20_35: { min: 20, max: 35 },
  OVER_35: { min: 35, max: Infinity }
};

const REFERENCE_PRODUCTS = [
  // < 10 €
  {
    id: 'bombe-de-bain-ananas-paradis-tropical',
    key: 'GALET',
    name: 'Bombe de Bain Ananas Paradis Tropical',
    desc: 'Une petite attention colorée, joyeuse et relaxante.',
    priceValue: 4.90,
    priceLabel: '4,90€',
    url: 'https://www.astroya.fr/products/bombe-de-bain-ananas-paradis-tropical',
    image: 'https://www.astroya.fr/cdn/shop/files/bombe_de_bain_paradis_tropical_ananas_ff74370a-fa37-4176-a837-409a284964f6.webp?v=1757404651&width=1780',
    emoji: '🚿',
    tag: 'Petit budget'
  },
  {
    id: 'sel-bain-aromatherapie-relaxant',
    key: 'GALET',
    name: 'Sel de Bain Aromathérapie Relaxant',
    desc: 'Un rituel bien-être simple et efficace pour se détendre.',
    priceValue: 9.90,
    priceLabel: '9,90€',
    url: 'https://www.astroya.fr/products/sel-bain-aromatherapie-relaxant',
    image: 'https://www.astroya.fr/cdn/shop/files/sels_bain_aromatherapie_lavande_et_orange_df2a38dc-6201-4ea4-a018-99b4297c8eba.webp?v=1758873457&width=1780',
    emoji: '🚿',
    tag: 'Mini spa'
  },
  {
    id: 'bougie-parfumee-goloka-70g',
    key: 'BOUGIE',
    name: 'Bougie Parfumée Goloka 70g',
    desc: 'Une bougie douce et accessible pour une jolie attention.',
    priceValue: 7.90,
    priceLabel: '7,90€',
    url: 'https://www.astroya.fr/products/bougie-parfumee-goloka-70g?variant=48197423792473',
    image: 'https://www.astroya.fr/cdn/shop/files/bougie_goloka_romarin.webp?v=1755849956&width=1780',
    emoji: '🕯️',
    tag: 'Ambiance'
  },
  {
    id: 'parfum-interieur-spray-orange-organic-goodness',
    key: 'PARFUM',
    name: "Parfum d’Intérieur Spray Orange",
    desc: 'Un cadeau sensoriel simple, frais et lumineux.',
    priceValue: 7.90,
    priceLabel: '7,90€',
    url: 'https://www.astroya.fr/products/parfum-interieur-spray-orange-organic-goodness',
    image: 'https://www.astroya.fr/cdn/shop/files/spray_organic_goodness_orange_75b8c185-32c6-4f0c-997d-1218511c4ec0.webp?v=1756115497&width=1780',
    emoji: '🌸',
    tag: 'Sensoriel'
  },
  {
    id: 'bruleur-encens-en-gres',
    key: 'ENCENS',
    name: 'Brûleur Encens en Grès',
    desc: 'Une idée zen et utile pour un petit cadeau soigné.',
    priceValue: 9.50,
    priceLabel: '9,50€',
    url: 'https://www.astroya.fr/products/bruleur-encens-en-gres',
    image: 'https://www.astroya.fr/cdn/shop/files/brule_encens_carre_en_gres.webp?v=1758174743&width=1780',
    emoji: '🪔',
    tag: 'Zen'
  },
  {
    id: 'bracelet-de-quartz-rose',
    key: 'BRACELET',
    name: 'Bracelet de Quartz Rose',
    desc: 'Un bracelet délicat, symbolique et plein de douceur.',
    priceValue: 8.90,
    priceLabel: '8,90€',
    url: 'https://www.astroya.fr/products/bracelet-de-quartz-rose',
    image: 'https://www.astroya.fr/cdn/shop/files/Bracelet_Calme_Paix_et_Tendresse_avec_Pierres_Naturelles_en_Quartz_Rose_1.webp?v=1770043400&width=1780',
    emoji: '📿',
    tag: 'Douceur'
  },

  // 10 - 20 €
  {
    id: 'bracelet-en-agate-4-mm',
    key: 'BRACELET',
    name: 'Bracelet en Agate 4 mm',
    desc: 'Un beau bijou simple et élégant pour un budget raisonnable.',
    priceValue: 15.90,
    priceLabel: '15,90€',
    url: 'https://www.astroya.fr/products/bracelet-en-agate-4-mm',
    image: 'https://www.astroya.fr/cdn/shop/files/bracelet_en_agate_4mm.webp?v=1756481257&width=1780',
    emoji: '📿',
    tag: 'Bijou'
  },
  {
    id: 'bougie-ayurvedique-kapha-sauge-menthe',
    key: 'BOUGIE',
    name: 'Bougie Ayurvédique Kapha Sauge Menthe',
    desc: 'Une bougie plus premium, idéale pour une maîtresse zen.',
    priceValue: 19.90,
    priceLabel: '19,90€',
    url: 'https://www.astroya.fr/products/bougie-ayurvedique-kapha-sauge-menthe',
    image: 'https://www.astroya.fr/cdn/shop/files/bougie_parfumee_sauge_menthe.webp?v=1754730658&width=1780',
    emoji: '🕯️',
    tag: 'Premium'
  },
  {
    id: 'pochette-velours-beige-fleur-de-vie',
    key: 'POCHETTE',
    name: 'Pochette Velours Beige Fleur de Vie',
    desc: 'Une pochette élégante et réutilisable qui fait un vrai joli cadeau.',
    priceValue: 19.90,
    priceLabel: '19,90€',
    url: 'https://www.astroya.fr/products/pochette-velours-beige-fleur-de-vie',
    image: 'https://www.astroya.fr/cdn/shop/files/pochette_velours_beige_broderie_fleurs_de_vie.webp?v=1756744577&width=1780',
    emoji: '👝',
    tag: 'Élégance'
  },
  {
    id: 'diffuseur-de-parfum-lavande-de-provence',
    key: 'PARFUM',
    name: 'Diffuseur de Parfum Lavande de Provence',
    desc: 'Une idée raffinée pour parfumer la maison tout en douceur.',
    priceValue: 18.90,
    priceLabel: '18,90€',
    url: 'https://www.astroya.fr/products/diffuseur-de-parfum-lavande-de-provence',
    image: 'https://www.astroya.fr/cdn/shop/files/diffuseur-de-parfum-100ml-lavande-de-provence-collection-authentique.webp?v=1762702579&width=1780',
    emoji: '🌸',
    tag: 'Maison'
  },
  {
    id: 'chantilly-douche-pamplemousse-160g',
    key: 'GALET',
    name: 'Chantilly Douche Pamplemousse',
    desc: 'Un cadeau bien-être original, joyeux et sensoriel.',
    priceValue: 17.90,
    priceLabel: '17,90€',
    url: 'https://www.astroya.fr/products/chantilly-douche-pamplemousse-160g',
    image: 'https://www.astroya.fr/cdn/shop/files/chantilly_douche_pamplemousse.webp?v=1753352869&width=1780',
    emoji: '🚿',
    tag: 'Cocooning'
  },
  {
    id: 'fleurs-de-savon-coeur-de-24-roses',
    key: 'FEMME',
    name: 'Fleurs de Savon Cœur de 24 Roses',
    desc: 'Une attention très visuelle et délicate, parfaite pour remercier.',
    priceValue: 15.90,
    priceLabel: '15,90€',
    url: 'https://www.astroya.fr/products/fleurs-de-savon-coeur-de-24-roses?variant=47777706213721',
    image: 'https://www.astroya.fr/cdn/shop/files/1311_883f32a6-eb57-4f26-bfb7-cc49f75b8416.jpg?v=1756666507&width=1780',
    emoji: '💝',
    tag: 'Très visuel'
  },
  {
    id: 'bruleur-dencens-yume-no-yume-feuille-de-bambou',
    key: 'ENCENS',
    name: 'Brûleur d’Encens Yume No Yume Feuille de Bambou',
    desc: 'Une idée poétique et zen pour la maison.',
    priceValue: 12.90,
    priceLabel: '12,90€',
    url: 'https://www.astroya.fr/products/bruleur-dencens-yume-no-yume-feuille-de-bambou',
    image: 'https://www.astroya.fr/cdn/shop/files/brule_encens_yomo_bambou.webp?v=1758198668&width=1780',
    emoji: '🪔',
    tag: 'Poétique'
  },

  // 20 - 35 €
  {
    id: 'panier-de-fleurs-de-savon',
    key: 'POCHETTE',
    name: 'Panier de Fleurs de Savon',
    desc: 'Un cadeau élégant, décoratif et très agréable à offrir.',
    priceValue: 25.90,
    priceLabel: '25,90€',
    url: 'https://www.astroya.fr/products/panier-de-fleurs-de-savon',
    image: 'https://www.astroya.fr/cdn/shop/files/IMG_1138.webp?v=1756666031&width=1780',
    emoji: '👝',
    tag: 'Très chic'
  },
  {
    id: 'ensemble-encens-fleur-de-vie',
    key: 'ENCENS',
    name: 'Ensemble Encens Fleur de Vie',
    desc: 'Un coffret spirituel et apaisant pour une ambiance sereine.',
    priceValue: 29.10,
    priceLabel: '29,10€',
    url: 'https://www.astroya.fr/products/ensemble-encens-fleur-de-vie-coffret-purification-energie-sacree',
    image: 'https://www.astroya.fr/cdn/shop/files/ensemble_encens_fleur_de_vie.webp?v=1768486338&width=1780',
    emoji: '🪔',
    tag: 'Spirituel'
  },
  {
    id: 'coffret-cadeaux-bougie-bracelet-verseau',
    key: 'TRESORS',
    name: 'Coffret Cadeaux Bougie Bracelet Verseau',
    desc: 'Un cadeau symbolique et original, parfait pour sortir du banal.',
    priceValue: 26.90,
    priceLabel: '26,90€',
    url: 'https://www.astroya.fr/products/coffret-cadeaux-bougie-bracelet-verseau',
    image: 'https://www.astroya.fr/cdn/shop/files/257699.jpg?v=1754742192&width=1780',
    emoji: '🌍',
    tag: 'Original'
  },
  {
    id: 'grand-carillon-a-vent-5-tubes-aluminium-et-bois',
    key: 'TRESORS',
    name: 'Grand Carillon à Vent 5 Tubes',
    desc: 'Une idée originale, zen et décorative qui change vraiment.',
    priceValue: 26.90,
    priceLabel: '26,90€',
    url: 'https://www.astroya.fr/products/grand-carillon-a-vent-5-tubes-aluminium-et-bois',
    image: 'https://www.astroya.fr/cdn/shop/files/grand-carillon-a-vent-5-tubes-aluminium-bois-65cm-astroya.jpg?v=1755442288&width=1780',
    emoji: '🌍',
    tag: 'Original'
  },
  {
    id: 'bracelet-turquoise-corail-et-agate-noir-ajustable-13-mm',
    key: 'BRACELET',
    name: 'Bracelet Turquoise Corail et Agate Noire',
    desc: 'Un bijou plus marquant pour un budget plus généreux.',
    priceValue: 24.90,
    priceLabel: '24,90€',
    url: 'https://www.astroya.fr/products/bracelet-turquoise-corail-et-agate-noir-ajustable-13-mm',
    image: 'https://www.astroya.fr/cdn/shop/files/bracelet_turquoise_corail_ajustable.webp?v=1756792140&width=1780',
    emoji: '📿',
    tag: 'Bijou chic'
  },
  {
    id: 'fleurs-de-savon-boite-ronde',
    key: 'FEMME',
    name: 'Fleurs de Savon Boîte Ronde',
    desc: 'Un cadeau raffiné, féminin et très agréable à présenter.',
    priceValue: 33.90,
    priceLabel: '33,90€',
    url: 'https://www.astroya.fr/products/fleurs-de-savon-boite-ronde?variant=48621588414809',
    image: 'https://www.astroya.fr/cdn/shop/files/66281.jpg?v=1756666230&width=1780',
    emoji: '💝',
    tag: 'Raffiné'
  },

  // 35 € et +
  {
    id: 'coffret-cadeau-spa-detente-totale',
    key: 'COFFRET',
    name: 'Coffret Cadeau Spa Détente Totale',
    desc: 'Un vrai coffret bien-être pour remercier en beauté.',
    priceValue: 38.90,
    priceLabel: '38,90€',
    url: 'https://www.astroya.fr/products/coffret-cadeau-spa-detente-totale',
    image: 'https://www.astroya.fr/cdn/shop/files/hope_hare_salle_de_bain_1.webp?v=1763793353&width=1780',
    emoji: '🎁',
    tag: 'Cagnotte'
  },
  {
    id: 'coffret-cadeau-bougie-bombes-de-bain-the-roses-provence',
    key: 'FEMME',
    name: 'Coffret Bougie & Bombes de Bain The Roses Provence',
    desc: 'Un cadeau premium et féminin qui fait son effet.',
    priceValue: 39.90,
    priceLabel: '39,90€',
    url: 'https://www.astroya.fr/products/coffret-cadeau-bougie-bombes-de-bain-the-roses-provence',
    image: 'https://www.astroya.fr/cdn/shop/files/coffret_cadeau_bougie_bombes_de_bain_violet.webp?v=1754919950&width=1780',
    emoji: '💝',
    tag: 'Premium'
  },
  {
    id: 'coffret-cadeau-bougie-bombes-bain-agrumes-epices-orientales',
    key: 'COFFRET',
    name: 'Coffret Bougie & Bombes de Bain Agrumes Épices',
    desc: 'Une belle idée collective, généreuse et chaleureuse.',
    priceValue: 39.90,
    priceLabel: '39,90€',
    url: 'https://www.astroya.fr/products/coffret-cadeau-bougie-bombes-bain-agrumes-epices-orientales',
    image: 'https://www.astroya.fr/cdn/shop/files/coffret_cadeau_bougie_bombes_de_bain_moutarde_1.webp?v=1754918097&width=1780',
    emoji: '🎁',
    tag: 'Généreux'
  },
  {
    id: 'bracelet-amazonite-a-facettes-8mm',
    key: 'BRACELET',
    name: 'Bracelet Amazonite à Facettes 8 mm',
    desc: 'Un bijou plus haut de gamme pour un cadeau qui marque.',
    priceValue: 35.90,
    priceLabel: '35,90€',
    url: 'https://www.astroya.fr/products/bracelet-amazonite-a-facettes-8mm',
    image: 'https://www.astroya.fr/cdn/shop/files/IMG_9456.webp?v=1756379550&width=1780',
    emoji: '📿',
    tag: 'Premium'
  },
  {
    id: '3-bougies-botaniques-chevrefeuille-citron',
    key: 'BOUGIE',
    name: '3 Bougies Botaniques Chèvrefeuille Citron',
    desc: 'Un très beau cadeau d’ambiance, plus généreux et premium.',
    priceValue: 49.90,
    priceLabel: '49,90€',
    url: 'https://www.astroya.fr/products/3-bougies-botaniques-chevrefeuille-citron',
    image: 'https://www.astroya.fr/cdn/shop/files/bougies_botaniques_chevrefeuille_citronne.webp?v=1763198251&width=1780',
    emoji: '🕯️',
    tag: 'Premium'
  },
  {
    id: 'bouquet-de-fleurs-de-savon-xl',
    key: 'POCHETTE',
    name: 'Bouquet de Fleurs de Savon XL',
    desc: 'Un cadeau très visuel, chic et impressionnant à offrir.',
    priceValue: 42.90,
    priceLabel: '42,90€',
    url: 'https://www.astroya.fr/products/bouquet-de-fleurs-de-savon-xl-30x20x12?variant=47777732755801',
    image: 'https://www.astroya.fr/cdn/shop/files/2997_f058a4eb-72d0-4cce-a436-6500339d5162.jpg?v=1756666361&width=1780',
    emoji: '👝',
    tag: 'Waouh'
  },
  {
    id: 'cadeau-bien-etre-tresors-du-monde-agadir',
    key: 'TRESORS',
    name: 'Cadeau Bien-être Trésors du Monde Agadir',
    desc: 'Un coffret sensoriel original pour une vraie belle surprise.',
    priceValue: 56.90,
    priceLabel: '56,90€',
    url: 'https://www.astroya.fr/products/cadeau-bien-etre-tresors-du-monde-agadir',
    image: 'https://www.astroya.fr/cdn/shop/files/coffret_cadeau_bien_etre_agadir_2_c06d16cd-4df2-4a92-8e0d-0887d14f58ee.webp?v=1769266522&width=1780',
    emoji: '🌍',
    tag: 'Voyage'
  },
  {
    id: 'coffret-cadeau-femme-tresors-du-japon',
    key: 'FEMME',
    name: 'Coffret Cadeau Femme Trésors du Japon',
    desc: 'Un cadeau premium, féminin et marquant pour une belle cagnotte.',
    priceValue: 68.90,
    priceLabel: '68,90€',
    url: 'https://www.astroya.fr/products/coffret-cadeau-femme-tresors-du-japon',
    image: 'https://www.astroya.fr/cdn/shop/files/coffret_cadeau_japon_2.webp?v=1758793723&width=1780',
    emoji: '💝',
    tag: 'Très premium'
  }
];

const CAROUSEL_ITEMS = [
  {
    name: 'Sel de Bain Relaxant',
    price: '9,90€',
    tag: 'Mini spa',
    emoji: '🚿',
    url: 'https://www.astroya.fr/products/sel-bain-aromatherapie-relaxant',
    image: 'https://www.astroya.fr/cdn/shop/files/sels_bain_aromatherapie_lavande_et_orange_df2a38dc-6201-4ea4-a018-99b4297c8eba.webp?v=1758873457&width=1780'
  },
  {
    name: 'Bracelet Quartz Rose',
    price: '8,90€',
    tag: 'Douceur',
    emoji: '📿',
    url: 'https://www.astroya.fr/products/bracelet-de-quartz-rose',
    image: 'https://www.astroya.fr/cdn/shop/files/Bracelet_Calme_Paix_et_Tendresse_avec_Pierres_Naturelles_en_Quartz_Rose_1.webp?v=1770043400&width=1780'
  },
  {
    name: 'Pochette Velours Fleur de Vie',
    price: '19,90€',
    tag: 'Élégance',
    emoji: '👝',
    url: 'https://www.astroya.fr/products/pochette-velours-beige-fleur-de-vie',
    image: 'https://www.astroya.fr/cdn/shop/files/pochette_velours_beige_broderie_fleurs_de_vie.webp?v=1756744577&width=1780'
  },
  {
    name: 'Coffret Spa Détente Totale',
    price: '38,90€',
    tag: 'Cagnotte',
    emoji: '🎁',
    url: 'https://www.astroya.fr/products/coffret-cadeau-spa-detente-totale',
    image: 'https://www.astroya.fr/cdn/shop/files/hope_hare_salle_de_bain_1.webp?v=1763793353&width=1780'
  },
  {
    name: 'Trésors du Monde Agadir',
    price: '56,90€',
    tag: 'Voyage',
    emoji: '🌍',
    url: 'https://www.astroya.fr/products/cadeau-bien-etre-tresors-du-monde-agadir',
    image: 'https://www.astroya.fr/cdn/shop/files/coffret_cadeau_bien_etre_agadir_2_c06d16cd-4df2-4a92-8e0d-0887d14f58ee.webp?v=1769266522&width=1780'
  }
];

let currentQ = 0;
let answers = new Array(QUESTIONS.length).fill(null);
let scores = {};
let imageCache = {};

renderQuestion(0);
buildCarousel();

// Sticky CTA: hide when quiz is visible
const obs = new IntersectionObserver((entries) => {
  const c = document.getElementById('stickyCta');
  if (c) c.classList.toggle('hidden', entries[0].isIntersecting);
}, { threshold: 0.3 });

const qb = document.getElementById('quizBox');
if (qb) obs.observe(qb);

function renderDots(idx) {
  const c = document.getElementById('stepDots');
  if (!c) return;

  c.innerHTML = QUESTIONS.map((_, i) => {
    let cl = 'step-dot';
    if (i < idx) cl += ' done';
    else if (i === idx) cl += ' active';
    return `<div class="${cl}"></div>`;
  }).join('');
}

function renderQuestion(idx) {
  const q = QUESTIONS[idx];
  const progressFill = document.getElementById('progressFill');
  if (progressFill) {
    progressFill.style.width = Math.round((idx / QUESTIONS.length) * 100) + '%';
  }

  renderDots(idx);

  const opts = q.options.map((o, i) => `
    <button
      class="option-btn${answers[idx] === i ? ' selected' : ''}"
      onclick="selectOption(${idx},${i})"
      aria-pressed="${answers[idx] === i}"
    >
      <div class="opt-top">
        <span class="opt-emoji">${o.emoji}</span>
        <span class="opt-label">${o.label}</span>
      </div>
      <span class="opt-desc">${o.desc}</span>
    </button>
  `).join('');

  document.getElementById('quizContent').innerHTML = `
    <div class="step-counter">
      <span>Question ${idx + 1} sur ${QUESTIONS.length}</span>
      <span class="step-emoji">${q.emoji}</span>
    </div>
    <div class="question-wrap">
      <p class="question-text">${q.question}</p>
      <div class="options-grid cols-${q.cols}">${opts}</div>
    </div>
    <div class="quiz-nav">
      <button class="btn-back${idx === 0 ? ' hidden' : ''}" onclick="goBack()">← Retour</button>
      <button
        class="btn-next"
        id="btnNext"
        ${answers[idx] === null ? 'disabled' : ''}
        onclick="goNext()"
      >
        ${idx === QUESTIONS.length - 1 ? 'Voir mes idées cadeaux 🎁' : 'Continuer →'}
      </button>
    </div>
  `;
}

function selectOption(qIdx, optIdx) {
  answers[qIdx] = optIdx;
  document.querySelectorAll('.option-btn').forEach((b, i) => {
    const selected = i === optIdx;
    b.classList.toggle('selected', selected);
    b.setAttribute('aria-pressed', selected);
  });

  const n = document.getElementById('btnNext');
  if (n) n.disabled = false;
}

function goNext() {
  if (answers[currentQ] === null) return;

  if (currentQ < QUESTIONS.length - 1) {
    currentQ++;
    renderQuestion(currentQ);
    document.getElementById('quizBox')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    computeScores();
    renderResults();
  }
}

function goBack() {
  if (currentQ > 0) {
    currentQ--;
    renderQuestion(currentQ);
    document.getElementById('quizBox')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function computeScores() {
  scores = {
    GALET: 0,
    BRACELET: 0,
    POCHETTE: 0,
    ENCENS: 0,
    COFFRET: 0,
    BOUGIE: 0,
    TRESORS: 0,
    PARFUM: 0,
    FEMME: 0
  };

  QUESTIONS.forEach((q, qi) => {
    const ai = answers[qi];
    if (ai === null) return;

    Object.entries(q.options[ai].scores).forEach(([k, v]) => {
      scores[k] = (scores[k] || 0) + v;
    });
  });
}

function getSelectedBudgetKey() {
  const budgetAnswerIndex = answers[0];
  if (budgetAnswerIndex === null) return null;
  return QUESTIONS[0].options[budgetAnswerIndex].budgetKey || null;
}

function isProductInBudget(product, budgetKey) {
  if (!budgetKey) return true;
  const range = BUDGET_RANGES[budgetKey];
  if (!range) return true;

  if (range.max === Infinity) {
    return product.priceValue >= range.min;
  }

  return product.priceValue >= range.min && product.priceValue < range.max;
}

function getProductsInBudget(budgetKey) {
  return REFERENCE_PRODUCTS.filter((product) => isProductInBudget(product, budgetKey));
}

function getRankedKeys() {
  return Object.entries(scores)
    .filter(([, value]) => value > 0)
    .sort((a, b) => b[1] - a[1])
    .map(([key]) => key);
}

function getBestProductForKey(key, budgetKey, excludedIds = new Set()) {
  const candidates = getProductsInBudget(budgetKey)
    .filter((product) => product.key === key && !excludedIds.has(product.id))
    .sort((a, b) => {
      if ((scores[b.key] || 0) !== (scores[a.key] || 0)) {
        return (scores[b.key] || 0) - (scores[a.key] || 0);
      }
      return a.priceValue - b.priceValue;
    });

  return candidates[0] || null;
}

function getFallbackProducts(budgetKey, excludedIds = new Set()) {
  return getProductsInBudget(budgetKey)
    .filter((product) => !excludedIds.has(product.id))
    .sort((a, b) => {
      const scoreA = scores[a.key] || 0;
      const scoreB = scores[b.key] || 0;

      if (scoreB !== scoreA) return scoreB - scoreA;
      return a.priceValue - b.priceValue;
    });
}

function getTopRecommendations(limit = 3) {
  const budgetKey = getSelectedBudgetKey();
  const rankedKeys = getRankedKeys();
  const selectedProducts = [];
  const usedIds = new Set();

  rankedKeys.forEach((key) => {
    if (selectedProducts.length >= limit) return;

    const product = getBestProductForKey(key, budgetKey, usedIds);
    if (product) {
      selectedProducts.push({
        ...product,
        matchScore: scores[key] || 0
      });
      usedIds.add(product.id);
    }
  });

  if (selectedProducts.length < limit) {
    const fallbackProducts = getFallbackProducts(budgetKey, usedIds);

    fallbackProducts.forEach((product) => {
      if (selectedProducts.length >= limit) return;

      selectedProducts.push({
        ...product,
        matchScore: scores[product.key] || 0
      });
      usedIds.add(product.id);
    });
  }

  return selectedProducts.slice(0, limit);
}

function renderResults() {
  const progressFill = document.getElementById('progressFill');
  if (progressFill) progressFill.style.width = '100%';

  renderDots(QUESTIONS.length);

  const recommendations = getTopRecommendations(3);
  const maxScore = Math.max(...recommendations.map((item) => item.matchScore || 1), 1);

  const rl = ['🥇 Notre coup de cœur', '🥈 Idée numéro 2', '🥉 Coup de bonus'];
  const rc = ['rank-1', 'rank-2', 'rank-3'];

  const cards = recommendations.map((product, i) => `
    <a
      href="${product.url}"
      target="_blank"
      rel="noopener"
      class="product-card ${rc[i]}"
      id="card-${product.id}"
    >
      <div class="product-img-wrap">
        <div class="product-rank ${rc[i]}">${rl[i]}</div>
        <div class="product-img-placeholder" id="placeholder-${product.id}">
          <span>${product.emoji}</span>
          <span class="ph-label">${product.tag}</span>
        </div>
      </div>

      <div class="product-score-bar">
        <div class="product-score-fill" id="score-${product.id}" style="width:0%"></div>
      </div>

      <div class="product-body">
        <span class="product-tag">${product.tag}</span>
        <h3 class="product-name">${product.name}</h3>
        <p class="product-desc">${product.desc}</p>
        <div class="product-footer">
          <span class="product-price">${product.priceLabel}</span>
          <span class="product-cta">Voir le produit →</span>
        </div>
        <div class="product-budget-note">✅ Compatible avec votre budget</div>
      </div>
    </a>
  `).join('');

  document.getElementById('quizContent').innerHTML = `
    <div class="results-wrap">
      <div class="results-header">
        <span class="trophy">🎉</span>
        <h2 class="results-title">Voici vos idées <em>cadeaux maîtresse</em> !</h2>
        <p class="results-sub">Sélectionnées selon vos réponses — la maîtresse va adorer 💕</p>
      </div>

      <div class="products-grid">${cards}</div>

      <div class="result-cta-block">
        <p>
          🎁 <strong>Cagnotte ou cadeau individuel</strong> — livraison express sous 24h, offerte dès 69€.<br>
          Commandez avant la fin de l'année scolaire !
        </p>
        <a
          href="https://www.astroya.fr/collections/idees-cadeaux-nouveautes"
          target="_blank"
          class="btn-shop-all"
        >
          Découvrir toutes nos idées →
        </a>
      </div>

      <button class="btn-restart" onclick="restartQuiz()">🔄 Recommencer le quiz</button>
    </div>
  `;

  recommendations.forEach((product) => {
    const pct = maxScore > 0 ? Math.round(((product.matchScore || 1) / maxScore) * 100) : 70;
    setTimeout(() => {
      const el = document.getElementById(`score-${product.id}`);
      if (el) el.style.width = pct + '%';
    }, 200);
  });

  recommendations.forEach((product) => applyImage(product.id, product.image, product.name));

  launchConfetti();
  document.getElementById('quizBox')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function applyImage(id, src, altText) {
  if (!src) return;
  const ph = document.getElementById(`placeholder-${id}`);
  const wrap = ph?.parentElement;
  if (!wrap) return;
  if (wrap.querySelector('img.loaded')) return;

  const img = document.createElement('img');
  img.alt = altText;
  img.loading = 'eager';
  img.onload = () => {
    img.classList.add('loaded');
    wrap.appendChild(img);
  };
  img.onerror = () => {};
  img.src = src;
}

function buildCarousel() {
  const track = document.getElementById('carouselTrack');
  if (!track) return;

  CAROUSEL_ITEMS.forEach((item, i) => {
    const card = document.createElement('a');
    card.href = item.url;
    card.target = '_blank';
    card.rel = 'noopener';
    card.className = 'carousel-card';
    card.id = `cc-${i}`;

    card.innerHTML = `
      <div class="cc-img" id="cc-img-${i}">
        <div class="cc-img-ph" id="cc-ph-${i}">
          <span>${item.emoji}</span>
        </div>
      </div>
      <div class="cc-body">
        <div class="cc-name">${item.name}</div>
        <div class="cc-price">${item.price}</div>
        <div class="cc-tag">${item.tag}</div>
      </div>
    `;

    track.appendChild(card);

    if (item.image) {
      applyCarouselImage(i, item.image, item.name);
    }
  });
}

function applyCarouselImage(idx, src, altText) {
  const wrap = document.getElementById(`cc-img-${idx}`);
  if (!wrap || wrap.querySelector('img.loaded') || !src) return;

  const img = document.createElement('img');
  img.alt = altText;
  img.loading = 'lazy';
  img.onload = () => {
    img.classList.add('loaded');
    wrap.appendChild(img);
  };
  img.onerror = () => {};
  img.src = src;
}

function scrollCarousel(dir) {
  const t = document.getElementById('carouselTrack');
  if (t) t.scrollBy({ left: dir * 210, behavior: 'smooth' });
}

function restartQuiz() {
  currentQ = 0;
  answers = new Array(QUESTIONS.length).fill(null);
  scores = {};
  renderQuestion(0);
  document.getElementById('quizBox')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function toggleFaq(btn) {
  const a = btn.nextElementSibling;
  const o = btn.classList.contains('open');

  document.querySelectorAll('.faq-q').forEach((b) => {
    b.classList.remove('open');
    b.nextElementSibling.style.maxHeight = '0';
  });

  if (!o) {
    btn.classList.add('open');
    a.style.maxHeight = a.scrollHeight + 'px';
  }
}

function launchConfetti() {
  const cv = document.getElementById('confetti-canvas');
  if (!cv) return;

  const ctx = cv.getContext('2d');
  if (!ctx) return;

  cv.width = window.innerWidth;
  cv.height = window.innerHeight;

  const cols = ['#E8547A', '#3D8A6E', '#C89B3C', '#F0B8CA', '#A8D5C2', '#FFD700'];
  const sh = ['rect', 'circle', 'star'];

  const ps = Array.from({ length: 100 }, () => ({
    x: Math.random() * cv.width,
    y: Math.random() * -cv.height,
    r: Math.random() * 8 + 4,
    color: cols[Math.floor(Math.random() * cols.length)],
    shape: sh[Math.floor(Math.random() * sh.length)],
    speed: Math.random() * 3 + 2,
    tilt: Math.random() * 10 - 5,
    rot: Math.random() * 360,
    rotS: Math.random() * 4 - 2
  }));

  let fr = 0;

  function drawStar(ctx, r) {
    ctx.beginPath();
    for (let i = 0; i < 5; i++) {
      const a1 = (i * 4 * Math.PI) / 5 - Math.PI / 2;
      const a2 = ((i * 4 + 2) * Math.PI) / 5 - Math.PI / 2;
      if (i === 0) ctx.moveTo(Math.cos(a1) * r, Math.sin(a1) * r);
      else ctx.lineTo(Math.cos(a1) * r, Math.sin(a1) * r);
      ctx.lineTo(Math.cos(a2) * (r / 2), Math.sin(a2) * (r / 2));
    }
    ctx.closePath();
    ctx.fill();
  }

  function draw() {
    ctx.clearRect(0, 0, cv.width, cv.height);

    ps.forEach((p) => {
      p.y += p.speed;
      p.x += Math.sin(fr / 20 + p.tilt) * 0.8;
      p.rot += p.rotS;

      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate((p.rot * Math.PI) / 180);
      ctx.fillStyle = p.color;

      if (p.shape === 'rect') {
        ctx.fillRect(-p.r / 2, -p.r / 2, p.r, p.r * 1.6);
      } else if (p.shape === 'circle') {
        ctx.beginPath();
        ctx.arc(0, 0, p.r / 2, 0, Math.PI * 2);
        ctx.fill();
      } else {
        drawStar(ctx, p.r);
      }

      ctx.restore();
    });

    if (++fr < 180) {
      requestAnimationFrame(draw);
    } else {
      ctx.clearRect(0, 0, cv.width, cv.height);
    }
  }

  draw();
}

} catch(error){console.error(error);}